<template>
  <a-spin :spinning="spinning">
    <div class="modal-header">
      <div class="modal-title">
        <span v-if="query.id">{{ l("Edit") }}</span>
        <span v-if="!query.id">{{ l("Create") }}</span>
      </div>
    </div>
    <a-form
      :label-col="{ span: 4 }"
      :wrapper-col="{ span: 20 }"
      :form="form"
      @submit="handleSubmit"
    >
      <a-row :gutter="24">
        <a-col :span="24">
          <a-form-item label="跳转地址" has-feedback>
            <a-input
              :disabled="isDisabled"
              style="width: 100%"
              placeholder="请输入跳转地址"
              v-decorator="[
                'linkAddress',
                {
                  rules: [
                    {
                      required: true,
                      message: l('validation.required'),
                    },
                  ],
                },
              ]"
            />
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="排序" has-feedback>
            <a-input
              :disabled="isDisabled"
              style="width: 100%"
              placeholder="请输入排序"
              v-decorator="[
                'sort',
                {
                  rules: [
                    {
                      required: true,
                      message: l('validation.required'),
                    },
                  ],
                },
              ]"
            />
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="状态" has-feedback>
            <a-select
              :disabled="isDisabled"
              v-decorator="[
                'status',
                {
                  rules: [
                    {
                      required: true,
                      message: l('validation.required'),
                    },
                  ],
                },
              ]"
            >
              <a-select-option
                v-for="(item, index) in statusList"
                :key="index"
                :value="item.code"
                >{{ item.text }}</a-select-option
              >
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item :label="l('图片')">
            <a-upload
              :action="uploadUrl"
              :multiple="false"
              :data="{ subdir: this.subdirName }"
              list-type="picture"
              :file-list="fileList"
              :showUploadList="{
                showPreviewIcon: true,
                showRemoveIcon: !isDisabled,
              }"
              @change="handleUploadChange"
            >
              <a-button v-if="!isDisabled">
                <a-icon type="upload" /> 上传附件
              </a-button>
            </a-upload>
          </a-form-item>
        </a-col>
      </a-row>
      <a-form-item class="btn--container" v-if="!isDisabled">
        <a-button type="button" @click="close()">
          {{ l("Cancel") }}
        </a-button>
        <a-button type="primary" html-type="submit">
          {{ l("Save") }}
        </a-button>
      </a-form-item>
    </a-form>
  </a-spin>
</template>
<script>
import { ModalComponentBase } from "@/shared/component-base";
import { ModalHelper } from "@/shared/helpers";
import { AdvertisingConfigServiceProxy } from "../services/advertisingconfig-proxies";
import moment from "moment";
import { AppConsts } from "@/abpPro/AppConsts";
import { environment } from "@/environments/environment";
export default {
  mixins: [ModalComponentBase],
  name: "create-or-edit-advertisingconfig",
  data() {
    return {
      // 获取到的数据
      entity: {},
      spinning: false,
      _serviceProxy: "",
      labelCol: {
        span: 5,
      },
      statusList: [
        { code: 1, text: "有效" },
        { code: 0, text: "禁用" },
      ],
      // 上传文件
      fileList: [],
      uploadUrl: "",
      subdirName: "",
      isDisabled: false,
    };
  },
  components: {},
  beforeCreate() {
    this.form = this.$form.createForm(this, {
      name: "register",
    });
  },
  created() {
    this.fullData(); // 模态框必须,填充数据到data字段
    this._serviceProxy = new AdvertisingConfigServiceProxy(
      this.$apiUrl,
      this.$api
    );
    this.uploadUrl = AppConsts.uploadBaseUrl + "/API/Upload";
    this.subdirName = environment.production ? "abpProd" : "abpDev";
  },
  async mounted() {
    console.log(this.query);
    if (this.query.id) {
      await this.getData();
      this.isDisabled = this.query.type === "preview";
    }
  },
  methods: {
    // 上传组件 @change
    handleUploadChange(info) {
      console.log(info);
      if (!this.query.id) {
        let isUpload = this.beforeUpload(info.file);
        if (!isUpload) {
          return false;
        }
      }
      let fileList = [...info.fileList];
      if (fileList.length > 1) {
        this.$message.error("只能上传一张照片!");
        return false;
      }
      fileList = fileList.map((file) => {
        if (file.response) {
          file.url = `${AppConsts.uploadBaseUrl}${file.response.data.Path}`;
        }
        return file;
      });
      this.fileList = fileList;
      // console.log(this.fileList);
    },
    /**
     * 获取数据
     */
    async getData() {
      this.spinning = true;
      var res = await this._serviceProxy.getEditById(this.query.id);
      this.spinning = false;
      this.$nextTick(() => {
        this.form.setFieldsValue({
          ...res,
        });
      });
      if (res.images && res.images.indexOf(",") !== -1) {
        let arr = res.images.split(",");
        arr.map((item, i) => {
          let n = item.split("/");
          this.fileList.push({
            uid: `-${i + 1}`,
            url: `${AppConsts.uploadBaseUrl}${item}`,
            name: n[n.length - 1],
            response: { data: { Path: item } },
            status: "done",
          });
        });
      } else if (res.images && res.images !== "undefined") {
        let n = res.images.split("/");
        this.fileList.push({
          uid: `-1`,
          url: `${AppConsts.uploadBaseUrl}${res.images}`,
          name: n[n.length - 1],
          response: { data: { Path: res.images } },
          status: "done",
        });
      }
    },
    /**
     * 提交表单
     */
    async handleSubmit(e) {
      e.preventDefault();
      let fileUrlList = [];
      this.fileList.map((item) => {
        fileUrlList.push(item.response.data.Path);
      });
      console.log(fileUrlList);
      let images =
        fileUrlList.length > 1 ? fileUrlList.join(",") : `${fileUrlList[0]}`;
      this.form.validateFieldsAndScroll(async (err, values) => {
        console.log(err);
        console.log(values);

        if (!err) {
          try {
            this.spinning = true;
            let res = await this._serviceProxy.createOrUpdate({
              ...values,
              id: this.query.id ? this.query.id : null,
              images: images,
            });
            this.spinning = false;
            console.log(res);
            if (res.status == 200) {
              this.$notification["success"]({
                message: this.l("SavedSuccessfully"),
              });
              this.success(true);
            }
          } catch {
            this.spinning = false;
          }
        }
      });
    },
    // 上传前校验
    beforeUpload(file) {
      const isJpgOrPng =
        file.type === "image/jpeg" ||
        file.type === "image/jpg" ||
        file.type === "image/png";
      if (!isJpgOrPng) {
        this.$message.error("只能上传jpg/png格式的照片!");
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("图片不得大于2MB!");
      }
      return isJpgOrPng && isLt2M;
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.btn--container {
  display: block;
  margin: 10px auto;
  text-align: center;
}
</style>